<template>
	<div class=" project">
		<div class="clear-both mb-2 mr-4" v-show="type==2">
			<el-button type="primary" class="fr" @click="postCusInfo" :loading="loadingAddBtn">{{loadingAddBtn?'保存中...':'保存'}}</el-button>
			<el-button class="fr mr-1" @click="isDisabled = false" :disabled="isEdit" v-show="isDisabled">编辑</el-button>
			<el-button class="fr mr-1" @click="isDisabled = true"  v-show="!isDisabled">取消</el-button>
		</div>
		<el-form :model="project" ref="projectForm" :rules="rules" label-position="left" label-width="120px"
			class="employer-ruleForm">
			<el-row v-show="type!=2">
				<el-col :span="24">
					<el-form-item label="" label-width="120px">
						<div>
							<el-radio v-model="project.company" label="1">有项目公司</el-radio>
							<el-radio v-model="project.company" label="2">暂无项目公司</el-radio>
						</div>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="type != 2">
				<el-col :span="24">
					<el-form-item label="企业名称" required label-width="120px">
						<seach v-show="project.company == '1'" @select="handleSelect" v-model="project.customerName"
							id="customerNameId1" ref="customerSearch"></seach>
						<el-input v-show="project.company == '2'" v-model="project.customerName" placeholder="请输入项目发起方名称"
							class="inp_text" id="customerNameId2" ref="customerInput"></el-input>

					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="项目名称" prop="name" label-width="120px">
						<el-input v-model="project.name" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<el-form-item label="项目状态" prop="status" label-width="120px">
						<el-select v-model="project.status" placeholder="请选择" style="width: 100%;"
							:disabled="isDisabled">
							<el-option v-for="item in projectStatusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<!-- <el-input v-model="project.status" :disabled="isDisabled"></el-input> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="投资方名称" prop="investorName" label-width="120px">
						<el-input v-model="project.investorName" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<!-- <el-form-item label="拟落地区域" label-width="120px">
												<el-input v-model="project.district" :disabled="isDisabled"></el-input>
											</el-form-item> -->
					<el-form-item label="产业类型" prop="industryType" label-width="120px">
						<!-- <el-input v-model="project.industryType" :disabled="isDisabled"></el-input> -->
						<el-cascader style="width: 100%;" v-model="project.industryType" :options="industryTypeOptions" :disabled="isDisabled">
						</el-cascader>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="投资总额" prop="investmentAmount" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.investmentAmount"
								:disabled="isDisabled"></el-input></div> 亿元
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<el-form-item label="预计年产值" prop="expectedAnnualOutput" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.expectedAnnualOutput"
								:disabled="isDisabled"></el-input></div>亿元
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="预计利润" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.expectedProfit"
								:disabled="isDisabled"></el-input></div>亿元
					</el-form-item>
				</el-col>
				<el-col :offset="3" :span="10">
					<el-form-item label="预计就业人数" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.expectedEmployment"
								:disabled="isDisabled"></el-input></div>人
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item label="税收" label-width="120px">
						<div class="fl mr-1"><el-input v-model="project.taxation"
								:disabled="isDisabled"></el-input></div>亿元
					</el-form-item>
				</el-col>
				 
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目附件" prop="projectFileList" label-width="120px">
						<el-upload :disabled="isDisabled" class="upload-demo"
							action="https://jsonplaceholder.typicode.com/posts/" :on-preview="handlePreview"
							:on-remove="handleRemove" multiple :limit="4" :before-remove="beforeRemove"
							:on-success="handleAvatarSuccess" :on-exceed="handleExceed"
							:file-list="project.projectFileList" :show-file-list="project.showFileList"
							accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.gif">
							<el-button size="small" type="primary" :disabled="isDisabled">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">仅支持上传 Word、PDF、图片文件，且单个文件大小不超过
								30MB</div>
						</el-upload>
						<!-- <span v-for="(file, index) in projectFileList" :key="index"
							v-show="projectFileList.length>0" class="curp display-block"
							@click="handleOpenURL(file.url)">{{file.name}} ></span> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目信息完整性评估" prop="" label-width="160px">
						<el-button type="primary" :loading="completenesLoading" @click="initEvaluation(1)">查看项目完整性评估</el-button>
						<!-- <el-button type="primary" v-show="!completenesLoading && completenessData!=''" @click="initEvaluation(2)">查看评估结果</el-button> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目简介" prop="summary" label-width="120px">
						<el-input type="textarea" v-model="project.summary" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目落地诉求" label-width="120px">
						<el-input type="textarea" v-model="project.demand" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目政策诉求" label-width="120px">
						<el-input type="textarea" v-model="project.policy" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="clear-both" v-show="type==1">
			<el-button type="primary" class="fr" @click="postCusInfo" :loading="loadingAddBtn">{{loadingAddBtn?'保存中...':'保存'}}</el-button>
			<!-- <el-button class="fr mr-1" @click="isDisabled = false">编辑</el-button> -->
		</div>
		<el-dialog class="localChain" custom-class="initiate_box_dialog" :title="dialogTitle" center
			:visible.sync="isInitiate" top="">
			<div class="pre-wrap-text" v-html="completenessData"></div>
		</el-dialog>
	</div>
</template>
<script>
import seach from './seach.vue';
export default {
	name: "addProject",
	components: { seach },
	data() {
		return {
			project: {
				name: '',
				summary: '',
				showFileList: true,
				status: '',
				investorName: '',
				district: '',
				industryType: [],
				investmentAmount: '',
				expectedAnnualOutput: '',
				expectedProfit: '',
				expectedEmployment: '',
				demand: '',
				policy: '',
				projectFileList: [],
				company: '1',
				customerName: '',
				taxation: '',
			},
			loadingAddBtn: false,
			tempProjectFileList: [], // 项目文件列表
			isDisabled: false,
			projectStatusOptions: [{ value: '1', label: '待处理' }, { value: '2', label: '处理中' }, { value: '3', label: '处理完成' }],
			industryTypeOptions: [{ value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' }],
			userdata: {},
			rules: {
				name: [
					{ required: true, message: '请输入项目名称', trigger: 'blur' },
				],
				status: [
					{ required: true, message: '请选择项目状态', trigger: 'change' },
				],
				industryType: [
					{ type: 'array', required: true, message: '请选择产业类型', trigger: 'change' },
				],
				investorName: [
					{ required: true, message: '请输入投资人名称', trigger: 'blur' },
				],
				investmentAmount: [
					{ required: true, message: '请输入投资总额', trigger: 'blur' },
				],
				expectedAnnualOutput: [
					{ required: true, message: '请输入预计年产值', trigger: 'blur' },
				],
				projectFileList: [
					{ required: true, message: '请上传项目文件', trigger: 'change' },
					{ type: 'array', min: 1, message: '请至少上传一个文件', trigger: 'change' }
				],
				summary: [
					{ required: true, message: '请输入项目简介', trigger: 'blur' },
				]
			},
			detailData: {},
			isInitiate: false,
			dialogTitle: '项目信息完整性评估',
			completenessData: '',
			completenesLoading: false,
		};
	},
	watch: {
		type: {
			handler(newValue, oldValue) {
			if(this.type==2){
				this.isDisabled = true;
			}else{
				this.isDisabled = false;
			}		
			}
		},
		projectData: {
			handler(newValue, oldValue) {
				console.log('项目数据:', newValue);
				this.pageData();
			},
			immediate: true,
			deep: true
		}
	},
	props: {
		type: { default: 1, type: Number },//1新增2详情页编辑
		projectData: { default() { }, type: Object },
		cusid: { default: 0, type: [String, Number] },
		isEdit: { default: false, type: Boolean },
	},
	created() {
		this.userdata = this.getuseriformation();
	},
	mounted() {
		this.getProjectClass();
		this.getStausType();
		if(this.type==2){this.isDisabled = true;}
	},
	methods: {
	//评估项目完整性
	initEvaluation(type) { 
		if(type==1){ 
			this.completeness();
		}else{
			this.isInitiate = true;
		}
	},
	completeness() {
            let that = this;
            let ajaxurl = this.$api.crm.assessment.Completeness(); 
			that.completenesLoading = true;
            this.$axios.get(ajaxurl + "?customerId=" + this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
					that.completenessData = res.data.data;
					console.log('评估结果',res.data.data);
					that.completenesLoading = false;
					that.isInitiate = true;
                }else{
					that.completenesLoading = false;
				}
            }).catch(function (error) {
                console.log(error);
				that.completenesLoading = false;
				that.$message.error(res.data.msg);
            });
        },
		pageData() {
			if (this.type == 2 && this.projectData) {
				const src = this.projectData || {};
				// 兼容父组件或后端不同字段命名
				this.project.name = src.name || src.project || '';
				this.project.summary = src.summary || src.remark || '';
				this.project.fileName = src.file || src.fileName || '';
				this.project.projectFileList = src.fileList || src.projectFileList || [];
				this.project.status = src.status || "";
				// industryType 可能以 bigClass/smallClass 或数组形式提供
				const big = src.bigClass !== undefined ? src.bigClass : (Array.isArray(src.industryType) ? src.industryType[0] : undefined);
				const small = src.smallClass !== undefined ? src.smallClass : (Array.isArray(src.industryType) ? src.industryType[1] : undefined);
				this.project.industryType = [big || '', small || ''];
				this.project.investmentAmount = src.amount || src.investmentAmount || "";
				this.project.expectedAnnualOutput = src.outputValue || src.expectedAnnualOutput || "";
				this.project.expectedProfit = src.profit || src.expectedProfit || "";
				this.project.expectedEmployment = src.employment || src.expectedEmployment || "";
				this.project.demand = src.landing || src.demand || '';
				this.project.policy = src.policy || '';
				this.project.investorName = src.investor || src.investorName || '';
				this.project.customerName = src.customerName || '';
				this.project.taxation = src.taxation || '';

				// 规范文件列表 item.name 字段
				if (this.project.projectFileList && this.project.projectFileList.length > 0) {
					this.project.projectFileList.forEach(item => {
						item.name = item.title || item.name;
					});
				}
			}
		},
		handleSelect(item) {
			console.log('选中项数据:', item);
			this.project.customerName = item.title;
		},
		// 获取项目产业类型
		getProjectClass() {
			let _this = this;
			let ajaxurl = this.$api.crm.parameter.projectClass();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					let datalist = res.data.list;
					_this.industryTypeOptions = datalist;
				}
			})
		},
		//获取项目状态类型
		getStausType() {
			let _this = this;
			let ajaxurl = this.$api.crm.parameter.projectStatus();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					let datalist = res.data.list;
					_this.projectStatusOptions = datalist;
				}
			})
		},
		handleRemove(file, fileList) {
			console.log('删除成功31232131231233');
			// console.log(file, fileList);
			this.deleteFile(file.fileId).then((res) => {
				if(res){
					this.project.projectFileList = fileList; // 更新文件列表 
				}
				
			})

			console.log(file, fileList);
		},
		handlePreview(file) {
			window.open(file.url);
		},
		handleAvatarSuccess(res, file, fileList) {
			this.project.projectFileList = fileList; // 更新文件列表
			if (this.project.projectFileList.length != 0 && this.type == 2) {
				this.uploadFileList(file.raw);
			} 
		},

		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file, fileList) {
			
			// this.projectFileList = fileList; // 删除文件列表
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		handleOpenURL(url) {
			// 打开新窗口
			window.open(url, '_blank');
		},
		//删除项目附件
		deleteFile(id) {
			
			return new Promise((resolve, reject) => {
				console.log('删除文件id:', id);
				if(this.type == 1) {
					reject(false);
					return;
				}
				// $.ajax({
				// 	type: "post",
				// 	url: this.$api.crm.customer.deleteFile(),
				// 	headers: {
				// 		AuthToken: this.userdata.token
				// 	},
				// 	data: { fileId: id  },
				// 	success: function (res) {
				// 		if (res.success) {
				// 			this.$message.success('删除成功！');
				// 		resolve(true);
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 		reject(false);
				// 	}
				// 	}
				// })
				let newFormData = new FormData();
				newFormData.append('fileId', id);
				this.$axios.post(this.$api.crm.customer.deleteFile(),newFormData , {
					headers: {
						'AuthToken': this.userdata.token, // 自定义请求头，传递 Token
						// 'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then((res) => {
					console.log(res);
					if (res.data.success) {
						this.$message.success('删除成功！');
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
						reject(false);
					}

				})
			});


		},
		//上传项目附件
		uploadFileList(file) {
			console.log('上传的文件', file);
			let addFileUrl = this.$api.crm.customer.addFile();
			// 添加项目附件到 FormData
			let formData = new FormData();
			formData.append('file', file); // 使用相同的字段名 'file', 支持多文件
			formData.append('customerId', this.detailData.id?this.detailData.id:this.cusid); // 客户 ID
			console.log('上传的文件', file);
			this.$axios.post(addFileUrl, formData, {
				headers: {
					'AuthToken': this.userdata.token // 自定义请求头，传递 Token
				}
			}).then((res) => {
				console.log(res);
				if (res.data.success) {
					// this.showFileList = false;

					// this.$message.success('上传成功！');
				} else {
					// this.$message.error(res.data.msg);
				}
			}).catch((error) => {
				console.log(error);
			})
		},
		//上传项目信息
		postCusInfo() {
			console.log('上传的项目信息', this.project);
			this.$refs['projectForm'].validate((valid) => {
				if (valid) {
					if (this.isDisabled) {
						this.$message.warning('请勿重复提交');
						return;
					}
					this.loadingAddBtn = true;
					// 创建 FormData 对象
					let formData = new FormData();
					formData.append('customerId', this.cusid == '' ? 0 : this.cusid); // 客户 ID
					formData.append('project', this.project.name); // 项目名
					formData.append('summary', this.project.summary); // 项目简介
					// formData.append('file', this.project.projectFileList.length > 0 ? this.project.projectFileList.map(file => file.raw) : ''); // 项目附件
					//bigClass要从projectStatus[0]获取,smallClass要从projectStatus[1]获取,怎么在projectStatus么有值的时候不报错
					formData.append('smallClass', this.project.industryType[1]);
					formData.append('bigClass', this.project.industryType[0]);
					formData.append('status', this.project.status);
					formData.append('amount', this.project.investmentAmount);
					formData.append('outputValue', this.project.expectedAnnualOutput);
					formData.append('profit', this.project.expectedProfit);
					formData.append('employment', this.project.expectedEmployment);
					formData.append('landing', this.project.demand);
					formData.append('policy', this.project.policy);
					formData.append('investor', this.project.investorName);
					formData.append('customerName', this.project.customerName);
					formData.append('taxation', this.project.taxation);

					// 打印 FormData 内容（调试用）
					for (let [key, value] of formData.entries()) {
						console.log(`${key}:`, value);
					}
					
					
					this.$emit('postCusInfo', formData);
					// return;
					// 使用 axios 发送 POST 请求
			this.$axios.post(this.$api.crm.project.Post(), formData, {
				headers: {
					// 'Content-Type': 'application/x-www-form-urlencoded',
					'AuthToken': this.userdata.token // 自定义请求头，传递 Token
					// 注意：不要手动设置 Content-Type，让浏览器自动处理
				}
			})
				.then((res) => {
					console.log(res);
					if (res.data.success) { // 假设后台返回的数据在 res.data 中
						this.$message({
							type: 'success',
							message: '添加成功!',
						});
						this.detailData = res.data.data;
						//在项目创建完成生成id后上传附件
						for(let i = 0; i < this.project.projectFileList.length; i++){
							this.uploadFileList(this.project.projectFileList[i].raw);
						}
						this.loadingAddBtn = false;
					} else {
						this.$message.error('添加失败：' + res.data.msg);
					}
					this.loadingAddBtn = false;
				})
				.catch((err) => {
					this.loadingAddBtn = false;
					console.error('上传失败:', err);
					// this.$message.error('上传失败，请稍后重试');
				});

				} else {
					console.log('error submit!!');
					this.$message.error('请填写完整的项目信息');
					return false;
				}
			});
			return;

		},
	}

};

</script>
<style scoped lang="scss">
::v-deep{

input[disabled],textarea[disabled]{
	background-color: #ffffff !important;
	border-color: #ffffff !important;
	color: #333 !important;
	cursor: auto !important;
}
	 
}
</style>